import { lazy, Suspense, useEffect } from "react";
import ErrorComponent from "./view/error_handling/ErrorComponent";
import { onShowLoading } from "./component/popup";
import { useAuth } from "../hooks/useAuth";
import { useWindowSize } from "../hooks/useWindowSize";
import { useInvoice } from "../hooks/useInvoice";
import { InvoiceResult } from "../domain/entity/Main";
import { useDownload } from "../hooks/useDownload";
import { useViewPayment } from "../hooks/useViewPayment";
import { useImage } from "../hooks/useImage";

const InvoiceMobileComponent = lazy(
  () => import("./view/invoice/mb/InvoiceComponent")
);
const InvoiceDesktopComponent = lazy(
  () => import("./view/invoice/dk/InvoiceComponent")
);

export const Main = () => {
  const { token, isAuthenticated, isTokenLoading } = useAuth();
  const { invoice, invoiceLoading, allExcludedTaxes, allIncludedTaxes } = useInvoice(token);
  const { logo, signature } = useImage(invoice?.logoPath ? invoice.logoPath : undefined, invoice?.signaturePath ? invoice.signaturePath : undefined);
  const { downloadFile } = useDownload();
  const { viewPayment } = useViewPayment({
    merchantEmail: invoice?.merchant.email,
    merchantName: invoice?.merchant.name,
    merchantPhoneNumber: invoice?.merchant.phoneNumber,
    totalAmount: invoice?.totalAmount});
  const { isDesktop } = useWindowSize();

  if (isTokenLoading) return <>{onShowLoading(true)}</>;
  if (!isAuthenticated) return <ErrorComponent />;

  return (
    <>
      <Suspense fallback={onShowLoading(true)}>
        {isDesktop ? (
          <InvoiceDesktopComponent
            invoice={invoice as InvoiceResult}
            isInvoiceLoading={invoiceLoading}
            allExcludedTaxes={allExcludedTaxes}
            allIncludedTaxes={allIncludedTaxes}
            downloadFile={downloadFile}
            viewPayment={viewPayment}
            logo={logo}
            signature={signature}
          />
        ) : (
          <InvoiceMobileComponent
            invoice={invoice as InvoiceResult}
            isInvoiceLoading={invoiceLoading}
            allExcludedTaxes={allExcludedTaxes}
            allIncludedTaxes={allIncludedTaxes}
            downloadFile={downloadFile}
            viewPayment={viewPayment}
            logo={logo}
            signature={signature}
          />
        )}
      </Suspense>
    </>
  );
};
